import { useAppContext } from "../../context/siteMapContext";
import { imageLoader, imageLoaderForStaticImages } from "../../context/utils";
import Image from 'next/image'

const ActionButton: React.FC = () => {
    const { highContrastOn, mainData } = useAppContext();
    const handleClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }
    return (
        <>
            {!mainData.competitionLogo?.fileUrl &&
                <div
                    className='fixed z-2 bottom-12 right-desktop h-20 w-20 lg:h-24 lg:w-24'
                    onClick={handleClick}>
                    <Image
                        loader={imageLoaderForStaticImages}
                        alt='Ugrás az oldal tetejére'
                        title='Ugrás az oldal tetejére'
                        src={highContrastOn ? '/footer/Icon_hc_navigation_up.svg' : '/footer/Icon_navigation_up.svg'}
                        layout='fill'
                        objectFit='cover'
                        width={60}
                        height={60}
                        className='cursor-pointer'
                    />
                </div>
            }
            {mainData.competitionLogo?.fileUrl && <div className="fixed right-0 2xl:sticky z-2 bottom-0 float-right mt-[-255px]">
                <div
                    className='sticky block ml-auto mb-6 z-2 bottom-72 right-desktop h-20 w-20 lg:h-24 lg:w-24'
                    onClick={handleClick}>
                    <Image
                        loader={imageLoaderForStaticImages}
                        alt='Ugrás az oldal tetejére'
                        title='Ugrás az oldal tetejére'
                        src={highContrastOn ? '/footer/Icon_hc_navigation_up.svg' : '/footer/Icon_navigation_up.svg'}
                        layout='fill'
                        objectFit='cover'
                        width={60}
                        height={60}
                        className='cursor-pointer'
                    />
                </div>
                <div
                    className='sticky z-2 bottom-0 right-nil h-[90px] lg:h-[180px] w-[150px] lg:w-[300px]'
                    onClick={() => { mainData.competitionLogoUrl ? window.open(mainData.competitionLogoUrl, '_blank') : null }}>
                    <Image
                        loader={imageLoader}
                        alt='Széchényi 2020'
                        title='Széchényi 2020'
                        src={mainData.competitionLogo.fileUrl}
                        layout='fill'
                        objectFit='cover'
                        width={124}
                        height={124}
                        className='cursor-pointer'
                    />
                </div>
            </div>}
        </>
    )
}

export default ActionButton;